<base-login-form [application]="application"></base-login-form>
<ng-template #baseOnboardingLight>
  <base-customer-onboarding-light
    [logo]="logo"
    [application]="application"
    [modalRef]="modalRef"
  ></base-customer-onboarding-light>
</ng-template>
